import qs from 'qs';
import client from './rest/AdminClient';
import { showToast } from '../stores/ToastStore';

export async function findPaymentPartners(query) {
  const queryString = qs.stringify(query);
  try {
    const result = await client({
      method: 'GET',
      path: `/api/payment-partners?${queryString}`,
    });
    return (result?.entity?.items || []).map((item) => ({
      ...item,
      _type: 'Partner',
    }));
  } catch (e) {
    showToast(
      'Failed to find payment partners',
      `Failed to find payment partners: ${e.entity.error}`,
      'error',
    );
    throw e;
  }
}
